<template>
  <div class="required-docs-filter">
    <div class="required-docs-filter__content">
      <div class="required-docs-filter__dropdown-box">
        <div class="dropdown">
          <h6
            v-click-outside="outsideClicked"
            @click="isActiveDropdown = !isActiveDropdown"
          >
            {{ selectedValue.name }}
            <span
              :class="{ active: isActiveDropdown }"
              class="caret"
            />
          </h6>
          <ul v-if="isActiveDropdown">
            <li
              v-for="(item, index) in dropdownItems"
              :key="index"
              class="option"
              @click="selectValue(item)"
            >
              {{ item.name }}
              <svg-loader
                v-if="selectedValue.prop === item.prop"
                src="/static/images/check-dropdown.svg"
              />
            </li>
          </ul>
        </div>
        <div class="field">
          <input
            v-if="
              selectedValue.prop === 'patientName' ||
                selectedValue.prop === 'osLis' ||
                selectedValue.prop === 'numberOsAlvaro'
            "
            v-model="formData[`${selectedValue.prop}`]"
            :placeholder="selectedValue.name"
            maxlength="199"
            :name="selectedValue.prop"
            @keydown.enter="search()"
          >

          <date-picker-range
            v-if="selectedValue.prop === 'date'"
            :date-selected.sync="date"
            :date-filter-alternative="true"
            :limit-data="limitDateForSearch"
            :calendar-direction="'top'"
            :clear-button="false"
            :default-start-date="oneWeekBeforeToday"
            :default-end-date="today"
          />
        </div>
      </div>

      <button
        class="required-docs-filter__btn"
        @click="search()"
      >
        Buscar
      </button>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '@/components/common/DatePickerRange'
import Moment from 'moment'
import { clickOutside } from '@/utils/directives'

export default {
  name: 'RequiredDocsFilter',
  components: {
    DatePickerRange
  },
  directives: {
    'click-outside': {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      }
    },
    clickOutside
  },
  props: {
    docPendent: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      isActiveDropdown: false,
      selectedValue: { name: 'Data de cadastro', prop: 'date' },
      dropdownItems: [
        { name: 'Data de cadastro', prop: 'date' },
        { name: 'Nome paciente', prop: 'patientName' },
        { name: 'OS LIS', prop: 'osLis' },
        { name: 'OS Alvaro', prop: 'numberOsAlvaro' }
      ],
      formData: {
        patientName: '',
        osLis: '',
        numberOsAlvaro: ''
      },
      limitDays: 10,
      date: {
        start: new Date(new Date().setDate(new Date().getDate() - 7)),
        end: new Date()
      }
    }
  },
  computed: {
    today() {
      return Moment(new Date()).format('DD/MM/YYYY')
    },
    oneWeekBeforeToday() {
      return Moment().subtract(1, 'weeks').format('DD/MM/YYYY')
    },
    limitDateForSearch() {
      return Moment(new Date()).subtract(this.limitDays, 'days').toDate()
    }
  },
  methods: {
    selectValue(selected) {
      this.isActiveDropdown = false
      this.selectedValue = selected
    },
    outsideClicked() {
      this.isActiveDropdown = false
    },
    search() {
      let data = {
        docPendent: this.docPendent
      }
      switch (this.selectedValue.prop) {
        case 'date':
          data['startDate'] = Moment(this.date.start).format('DD/MM/YYYY')
          data['endDate'] = Moment(this.date.end).format('DD/MM/YYYY')
          break
        case 'patientName':
          data['patientName'] = this.formData.patientName
          break
        case 'osLis':
          data['osLis'] = this.formData.osLis
          break
        case 'numberOsAlvaro':
          data['numberOsAlvaro'] = this.formData.numberOsAlvaro
          break
      }

      localStorage.setItem('docFilters', JSON.stringify(data))
      this.$emit('updateList', data)
    }
  }
}
</script>

<style lang="scss">
  .required-docs-filter {
    width: 100%;
    z-index: 10;
    font-family: 'Exo 2' !important;

    .subtitle {
      font-size: 16px;
      font-weight: 600;
      color: #7a7a7a;
    }

    &__content {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
      margin-bottom: 20px;
    }

    &__dropdown-box {
      display: flex;
      border: 1px solid #ccc;
      border-radius: 6px;
      flex: 1;
      flex-wrap: nowrap;
      justify-content: space-between;
      min-height: 40px;
      align-items: center;
      background-color: #fff;

      h6 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 160px;
        padding: 8px;
        font-weight: 500;
        font-size: 13px;
        color: #999;
        cursor: pointer;

        .caret {
          width: 0;
          height: 0;
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
          border-bottom: 6px solid #7f1a54;
          border-radius: 6px;
          transform: rotate(180deg);
          transition: all ease-out 0.3s;

          &.active {
            transform: rotate(0deg);
          }
        }
      }

      .dropdown {
        border-right: 1px solid #ccc;
        position: relative;

        ul {
          width: 142px;
          display: flex;
          flex-wrap: wrap;
          padding: 8px;
          background: #ffffff;
          box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.15);
          border-radius: 4px;
          position: absolute;
          left: 0;
          top: 44px;
        }

        li {
          width: 100%;
          padding: 9px;
          margin: 0;
          font-size: 14px;
          color: #363636;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background-color: #ffffff;
          transition: all ease 0.3s;
          cursor: pointer;

          &:hover {
            background-color: #e9e9e9;
            border-radius: 4px;
          }

          i {
            margin: 0;
          }
        }
      }

      .field {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-grow: 1;
        flex-shrink: 1;

        input {
          font-weight: 500;
          font-size: 13px;
          line-height: 16px;
          color: #999999;
          height: 40px;
          padding: 0 8px;
          border: none;
          flex-grow: 1;
          outline: none;
        }
      }

      &__btn {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 0px 4px 4px 0px;
        width: 40px;
        height: 40px;
        cursor: pointer;

        .md-icon {
          width: 15px;
          min-width: 15px;
          height: 15px;
          min-height: 15px;
        }

        svg {
          path {
            fill: white;
          }
        }
      }

      .date-range-container {
        flex: 1;
        font-family: 'Exo 2' !important;

        .search-bar__date {
          border: 2px solid #d8d8d8;
          border-right: none;
          height: 2.5em;
        }

        &-label {
          color: #7a7a7a;
          text-align: left;
          font-size: 12px;
          font-weight: 500;
          padding-top: 5px;
          padding-right: 10px;
          letter-spacing: 1px;
          text-transform: uppercase;
          font-family: 'Exo 2' !important;
        }

        .search-bar__date {
          margin: 0;
        }

        .md-input-container {
          border-right: 2px solid #d8d8d8;
          padding: 0 5px;
          min-height: 0;
          margin: 0;

          .md-input {
            padding-left: 10px;
            font-family: 'Exo 2' !important;
          }
        }
      }

      .popover-content-wrapper {
        position: fixed !important;
      }

      .search-bar__date {
        margin: 0;
      }

      .alternative .md-input-container {
        margin: 0;
        padding: 0;
        height: 40px;
        min-height: inherit !important;

        input {
          font-weight: 500;
          font-size: 14px;
        }

        i {
          margin: 8px;
        }
      }
    }

    &__btn {
      height: 40px;
      width: 160px;
      background-color: #7f1a54;
      text-transform: uppercase;
      font-family: 'Exo 2' !important;
    }
  }
</style>
